const productsHotel = [
  {
    id: 28,
    pinPos: [267.89229141129374, 25.03641069707578, 25.093264796039193],
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: 303.7196177707818,
        y: 202.84222142447288,
        z: 176.65362492007995,
      },
      target: {
        x: 303.4217693826737,
        y: 202.0761769813539,
        z: 176.08400904173038,
      },
      posMobile: {
        x: 303.7196177707818,
        y: 202.84222142447288,
        z: 176.65362492007995,
      },
      targetMobile: {
        x: 303.4217693826737,
        y: 202.0761769813539,
        z: 176.08400904173038,
      },
    },
    cameraOut: {
      pos: {
        x: 73.59009135063795,
        y: 230.56464915883635,
        z: 173.95759400526947,
      },
      target: {
        x: 74.52919892824207,
        y: 230.62962406125308,
        z: 173.62016961412021,
      },
    },
  },
  {
    id: 29,
    pinPos: [-545.1319772575414, 183.60249767318606, 462.0062074020159],
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: -439.2635743977741,
        y: 228.41690927636915,
        z: 394.91654484414136,
      },
      target: {
        x: -439.9192060487187,
        y: 227.98711250901195,
        z: 395.53736839157574,
      },
      posMobile: {
        x: -439.2635743977741,
        y: 228.41690927636915,
        z: 394.91654484414136,
      },
      targetMobile: {
        x: -439.9192060487187,
        y: 227.98711250901195,
        z: 395.53736839157574,
      },
    },
    cameraOut: {
      pos: {
        x: 74.98424755595558,
        y: 230.85652947851136,
        z: 174.01233105099843,
      },
      target: {
        x: 74,
        y: 230.6801642501449,
        z: 174,
      },
    },
  },
  {
    id: 30,
    pinPos: [-380.964166803985, 337.2504973890136, 377.58214065966257],
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: -560.2871113934063,
        y: 289.0929582475485,
        z: 415.5942156301732,
      },
      target: {
        x: -559.3820272814867,
        y: 289.32837432922463,
        z: 415.2400941554802,
      },
      posMobile: {
        x: -560.2871113934063,
        y: 289.0929582475485,
        z: 415.5942156301732,
      },
      targetMobile: {
        x: -559.3820272814867,
        y: 289.32837432922463,
        z: 415.2400941554802,
      },
    },
    cameraOut: {
      pos: {
        x: 74.98424755595558,
        y: 230.85652947851136,
        z: 174.01233105099843,
      },
      target: {
        x: 74,
        y: 230.6801642501449,
        z: 174,
      },
    },
  },
  {
    id: 31,
    pinPos: [-425.7090560686614, 309.93726343659847, -17.20449802011069],
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: -515.1766265540053,
        y: 229.4955365949469,
        z: 207.2094911233294,
      },
      target: {
        x: -514.9798855920274,
        y: 229.7614063150411,
        z: 206.265771733989,
      },
      posMobile: {
        x: -515.1766265540053,
        y: 229.4955365949469,
        z: 207.2094911233294,
      },
      targetMobile: {
        x: -514.9798855920274,
        y: 229.7614063150411,
        z: 206.265771733989,
      },
    },
    cameraOut: {
      pos: {
        x: 74.98424755595558,
        y: 230.85652947851136,
        z: 174.01233105099843,
      },
      target: {
        x: 74,
        y: 230.6801642501449,
        z: 174,
      },
    },
  },
  {
    id: 32,
    pinPos: [-185.83722715777742, 180.82711290852723, -84.73788915515001],
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: -93.79449373299545,
        y: 254.24999983240346,
        z: 151.35686846648457,
      },
      target: {
        x: -94.28121907735003,
        y: 253.89997145300558,
        z: 150.55650694018598,
      },
      posMobile: {
        x: -93.79449373299545,
        y: 254.24999983240346,
        z: 151.35686846648457,
      },
      targetMobile: {
        x: -94.28121907735003,
        y: 253.89997145300558,
        z: 150.55650694018598,
      },
    },
    cameraOut: {
      pos: {
        x: 74.98424755595558,
        y: 230.85652947851136,
        z: 174.01233105099843,
      },
      target: {
        x: 74,
        y: 230.6801642501449,
        z: 174,
      },
    },
  },
  {
    id: 33,
    pinPos: [118.27214779394598, 251.50194428068386, 265.72261649833183],
    scale: 0.5,
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: 14.000273347893131,
        y: 239.91548126715327,
        z: 149.93745476335693,
      },
      target: {
        x: 14.776922678611378,
        y: 240.05766198860852,
        z: 150.5511325774755,
      },
      posMobile: {
        x: 14.000273347893131,
        y: 239.91548126715327,
        z: 149.93745476335693,
      },
      targetMobile: {
        x: 14.776922678611378,
        y: 240.05766198860852,
        z: 150.5511325774755,
      },
    },
    cameraOut: {
      pos: {
        x: 73.80509054802353,
        y: 230.64491357455617,
        z: 172.930652910566,
      },
      target: {
        x: 74.52919892824207,
        y: 230.62962406125308,
        z: 173.62016961412021,
      },
    },
  },
  {
    id: 34,
    pinPos: [-557.6888376508346, 206.96083799140783, -68.91914919173024],
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: -577.3382530276155,
        y: 157.9806620839659,
        z: 120.5466149616887,
      },
      target: {
        x: -577.3999950478548,
        y: 158.20881222310067,
        z: 119.57494864193198,
      },
      posMobile: {
        x: -577.3382530276155,
        y: 157.9806620839659,
        z: 120.5466149616887,
      },
      targetMobile: {
        x: -577.3999950478548,
        y: 158.20881222310067,
        z: 119.57494864193198,
      },
    },
    cameraOut: {
      pos: {
        x: 74.98424755595558,
        y: 230.85652947851136,
        z: 174.01233105099843,
      },
      target: {
        x: 74,
        y: 230.6801642501449,
        z: 174,
      },
    },
  },
  {
    id: 35,
    pinPos: [-359.297008298921, 28.514758249438874, 309.8175989349081],
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: -559.7503147398625,
        y: 290.0860132772626,
        z: 415.65544840628263,
      },
      target: {
        x: -559.2912506063328,
        y: 289.31996883414365,
        z: 415.2055194869262,
      },
      posMobile: {
        x: -559.7503147398625,
        y: 290.0860132772626,
        z: 415.65544840628263,
      },
      targetMobile: {
        x: -559.2912506063328,
        y: 289.31996883414365,
        z: 415.2055194869262,
      },
    },
    cameraOut: {
      pos: {
        x: 74.98424755595558,
        y: 230.85652947851136,
        z: 174.01233105099843,
      },
      target: {
        x: 74,
        y: 230.6801642501449,
        z: 174,
      },
    },
  },
  {
    id: 36,
    pinPos: [294.2834793717857, 336.6694806178211, 126.1570321962748],
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: 128.95937645592804,
        y: 275.44083746490605,
        z: 194.95084273291482,
      },
      target: {
        x: 129.76091163249896,
        y: 275.73268108599757,
        z: 194.42895322205297,
      },
      posMobile: {
        x: 128.95937645592804,
        y: 275.44083746490605,
        z: 194.95084273291482,
      },
      targetMobile: {
        x: 129.76091163249896,
        y: 275.73268108599757,
        z: 194.42895322205297,
      },
    },
    cameraOut: {
      pos: {
        x: 73.59009135063795,
        y: 230.56464915883635,
        z: 173.95759400526947,
      },
      target: {
        x: 74.52919892824207,
        y: 230.62962406125308,
        z: 173.62016961412021,
      },
    },
  },
  {
    id: 37,
    pinPos: [-783.8789894397311, 250.91875247604304, 196.5363743315507],
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: -576.507095080917,
        y: 157.82753479237977,
        z: 119.12737055240652,
      },
      target: {
        x: -577.3066116999016,
        y: 158.21918686307347,
        z: 119.58276250610004,
      },
      posMobile: {
        x: -576.507095080917,
        y: 157.82753479237977,
        z: 119.12737055240652,
      },
      targetMobile: {
        x: -577.3066116999016,
        y: 158.21918686307347,
        z: 119.58276250610004,
      },
    },
    cameraOut: {
      pos: {
        x: 74.98424755595558,
        y: 230.85652947851136,
        z: 174.01233105099843,
      },
      target: {
        x: 74,
        y: 230.6801642501449,
        z: 174,
      },
    },
  },
  {
    id: 61,
    pinPos: [247.52312503577085, 248.8622197829522, -87.86329428660946],
    scale: 0.8,
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: 149.76603413212177,
        y: 110.61114477487645,
        z: 183.20640894405295,
      },
      target: {
        x: 149.9064867585128,
        y: 111.03548711788652,
        z: 182.3118662476608,
      },
      posMobile: {
        x: 149.76603413212177,
        y: 110.61114477487645,
        z: 183.20640894405295,
      },
      targetMobile: {
        x: 149.9064867585128,
        y: 111.03548711788652,
        z: 182.3118662476608,
      },
    },
    cameraOut: {
      pos: {
        x: 73.59009135063795,
        y: 230.56464915883635,
        z: 173.95759400526947,
      },
      target: {
        x: 74.52919892824207,
        y: 230.62962406125308,
        z: 173.62016961412021,
      },
    },
  },
  {
    id: 62,
    pinPos: [330.2176122462815, 154.82771347634088, 217.52537780664608],
    scale: 0.8,
    animationSpeed: 0.1,
    selected: false,
    hovered: false,
    cameraIn: {
      pos: {
        x: 157.9672161652091,
        y: 222.55869035047527,
        z: 136.63834499530634,
      },
      target: {
        x: 158.85512587797874,
        y: 222.16334174314434,
        z: 136.87353815135228,
      },
      posMobile: {
        x: 157.9672161652091,
        y: 222.55869035047527,
        z: 136.63834499530634,
      },
      targetMobile: {
        x: 158.85512587797874,
        y: 222.16334174314434,
        z: 136.87353815135228,
      },
    },
    cameraOut: {
      pos: {
        x: 73.59009135063795,
        y: 230.56464915883635,
        z: 173.95759400526947,
      },
      target: {
        x: 74.52919892824207,
        y: 230.62962406125308,
        z: 173.62016961412021,
      },
    },
  },
];

export default productsHotel;
